import { BaseService } from "./base.service";
import { PricingDictionaryResponse } from "@model/models";

class Service extends BaseService {
    async dictionary(): Promise<PricingDictionaryResponse> {
        return this.get('/dictionary');
    }
}

export const PricingService = new Service('/pricing');